import * as React from "react";
import { connect } from "react-redux";

import JSONTree from "react-json-tree";

import { IState } from "../../classes/state";

import * as widthActions from "../../actions/widthActions";

import ResponsiveCalendar from "./ResponsiveCalendar";

export class CalendarContainer extends React.Component<any, any> {

  public constructor(props: any, context: any) {
    super(props, context);

    this.widthHasChanged = this.widthHasChanged.bind(this);
  }

  public widthHasChanged(width: number) {
    this.props.widthHasChanged(width);
  }

  public render() {
    return (
      <React.Fragment>

        {/* <JSONTree data={this.props.theState} /> */}

        <ResponsiveCalendar
          displayedEventId={this.props.displayedEventId}
          eventScreenMode={this.props.eventScreenMode}
          iCalStartDate={this.props.iCalStartDate}
          portletInstanceId={this.props.portletInstanceId}
          viewMode={this.props.viewMode}
          onWidthChanged={this.props.widthHasChanged}
        />

      </React.Fragment>
    );
  }

}

const mapStateToProps = (state: IState, ownProps: any) => { // 'state' is the state in our Redux Store; 'ownProps' is a reference to this component's own this.props.
  return {
    displayedEventId: state.calendarSettings.displayedEventId,
    eventScreenMode: state.calendarSettings.eventScreenMode,
    iCalStartDate: state.calendarSettings.iCalStartDate,
    portletInstanceId: state.calendarSettings.portletInstanceId,
    // theState: state,
    viewMode: state.calendarSettings.viewMode,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    widthHasChanged: (width: number) => {
      dispatch(widthActions.widthChangedAction(width));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarContainer);
